module.exports = __webpack_public_path__ + "img/status-report-badge-2.854a6870.svg";